module.exports = __webpack_public_path__ + "images/landing/video-previews/bang_club_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/bang_club_2x.jpg
// module id = cbpy
// module chunks = 1